import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header/index.js";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; // Import the JSON file
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import usePavanData from "./hooks/usePavanData";

// // Import the September2023.json file
import October2023 from "./components/Body/October2023.json";
const Footer = lazy(() => import("./components/Footerupdated/Footer.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));
const EventComponent = lazy(() => import("./components/Event/Event.js"));
// const ShiningStar = lazy(() => import("./components/ShiningStar/shiningstar.js"));

function App() {
  const pavanData = usePavanData();
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();
  const [aiBrandingData, setAiBrandingData] = useState();
  const [links, setLinks] = useState(null); // Set initial state as null

  const appVersion = appversion.version;

  useEffect(() => {
    //Comment out the axios request if we're using the local JSON
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_OCTOBERJSON_CDN_URL)
        .then(response => {
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();

    // Set the data from the local JSON file
    // setWebinarData(September2023);
    // setBannerData(September2023.banner);
    // setHighlightsData(September2023.highlights);
    // setPropertyData(September2023.property);
    // setTimerData(September2023.countdown);
    // setFormData(September2023.signupform);
  }, []);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);
  const fetchAiBrandingJson = async () => {
    try {
      await axios
        .get(process.env.REACT_APP_ANGELAI_JSON)
        .then((response) => {
          // console.log(JSON.stringify(response.data));
          setAiBrandingData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (e) {
      console.log(e);
    }
  };


  return (
    <div className="bodyContainer">
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={true}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <>
          <Header fetchpriority="high" aiBrandingData={aiBrandingData} />
          {bannerData ?
            <>
              <Body bannerData={bannerData} timerData={timerData} formData={formData} links={links} fetchpriority="high" />

              {/* <Suspense fallback={<div />}>
      <LogoSection fetchpriority="low" />
      </Suspense> */}
              <Suspense fallback={<div />}>
                {highlightsData ?
                  <Highlights highlightsData={highlightsData} links={links} />
                  : ""}
              </Suspense>
              <Suspense fallback={<div />}>
                {propertyData ?
                  <Proprty propertyData={propertyData} links={links} />
                  : ""}
              </Suspense>
              <Suspense fallback={<div />}>
                <EventComponent links={links} />
              </Suspense>
              {/* <Suspense fallback={<div />}>
                <ShiningStar links={links} />
              </Suspense> */}
              <Suspense fallback={<div />}>
                <Morganlogos links={links} />
              </Suspense>
              <Suspense fallback={<div />}>
                <Whysunwest links={links} pavanData={pavanData} />
              </Suspense>
              <Suspense fallback={<div />}>
                <Footer />
              </Suspense>
            </>
            : ""}
        </>
      </CacheBuster>
    </div>
  );
}

export default App;
